import { useEffect } from "react";

export const ScrollToTop = ({
  changeKey,
  rerunOnKeyChange = false,
  scrollIntoView = false,
}: {
  changeKey?: string | number;
  rerunOnKeyChange?: boolean;
  scrollIntoView?: boolean;
}) => {
  useEffect(() => {
    if (rerunOnKeyChange) {
      if (document?.getElementById("appMainBody")) {
        document.getElementById("appMainBody")!.scrollTop = 0;
      }

      if (scrollIntoView) {
        if (document?.getElementById("pageTopRefToScroll")) {
          document
            .getElementById("pageTopRefToScroll")!
            .scrollIntoView({ behavior: "smooth" });
        }
      }
    }
    // eslint-disable-next-line
  }, [changeKey]);

  return null;
};
